import { vehicle_sharingService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, vehicle_sharings: [], vehicle_sharing: {} };

const actions = {
    add({ dispatch, commit }, data) {
        commit('request');

        vehicle_sharingService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/vehicle_sharings');
                    dispatch('alert/success', "Vehicle Sharing Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/vehicle_sharings');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      vehicle_sharingService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/vehicle_sharings');
                  dispatch('alert/success', "Vehicle Sharing Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/vehicle_sharings');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_vehicle_sharing_by_account({ dispatch, commit }, data) {
        commit('request');

        vehicle_sharingService.get_vehicle_sharing_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  vehicle_sharings: state => {
    return state.vehicle_sharings
  },
  vehicle_sharing: state => {
    return state.vehicle_sharing
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.vehicle_sharing = {};
        state.vehicle_sharings = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.vehicle_sharing = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.vehicle_sharings = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const vehicle_sharings = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
